module.exports = __webpack_public_path__ + "danger.28cbecb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/articles/danger.png
// module id = 1906
// module chunks = 0